import React from 'react'
import aboutImage from '../../assets/images/About.jpg'
import aboutImage2 from '../../assets/images/care_hawaii3.JPG'
import PageCreator from '../../components/PageCreator'
import '../../assets/scss/index.scss'

import {Container, Col, Row } from 'react-bootstrap'

export default function index() {
    return (
        <PageCreator imageName={aboutImage} opacityLevel='0.9'>
            <p className='mainFont' style={{ color: "#222222", fontSize: '1.5em', margin: '0' }}>What We're About</p>

            <hr style={{ backgroundColor: "#222222" }} />
            <Container>
         
                <br />
                <Row>
                    <Col>
                        <p className='mainFont' style={{ color: "#222222" }}>
                        <img alt="Hawaii Mountains" style={{ width: '25vw', float: 'left', marginRight: '15px' }} src={aboutImage2} />CARE Hawaii, Inc. was founded in 1999 to provide outpatient mental health services to Hawaii's children, adolescents and adults
                                through a network of mental health professionals committed to best
                                practices in service delivery. CARE Hawaii, Inc. services individuals
                                with serious mental illness, developmental delays, and substance related
                                issues. With available services throughout the State of Hawaii, CARE
                                Hawaii Inc.'s mission is to provide a comprehensive array of behavioral
                                health services to promote the physical, emotional, social, spiritual,
                                recreational, and educational development of all identified consumers
                                and their families/significant others.

                        </p>
                    </Col>
                </Row>
                < hr />
                <Row>
                    <Col>
                      
                        <p className='mainFont' style={{ color: "#222222", fontSize: '1.25em', margin: '0' }}>Our Vision</p>
                        <p className='mainFont' style={{ color: "#222222", fontSize: '1em', margin: '0' }}>
                            CARE Hawaii’s vision is that every child, adolescent, adult, and their family/significant other
                            in Hawaii will have maximum opportunity to reach their potential in all spheres of their
                            lives.
                        </p>
                        <br />
                        <p className='mainFont' style={{ color: "#222222", fontSize: '1.25em', margin: '0' }}>Our Mission</p>
                        <p className='mainFont' style={{ color: "#222222", fontSize: '1em', margin: '0' }}>
                        CARE Hawaii’s mission is to provide a comprehensive array of mental health and addiction
                        services to promote the physical, emotional, spiritual, and educational development of all
                        identified clients and their families/significant others.
                        </p>
                        <br />
                        <p className='mainFont' style={{ color: "#222222", fontSize: '1.25em', margin: '0' }}>Our Philosophy</p>
                        <p className='mainFont' style={{ color: "#222222", fontSize: '1em', margin: '0' }}>
                        The philosophy of treatment and services embraced by CARE Hawaii is that of empowering
                        all clients and their families/ significant others with skills to successfully meet the challenges
                        of growth and development.
                        </p>
                    </Col>
                </Row>
                <hr />
                <br />
                
   

            </Container>

        </PageCreator>
    )
}
